<template>
    <div>
        <el-card class="mb-5">
            <el-form inline>
                <el-form-item label="时间范围" style="margin-bottom: 0;">
                    <el-date-picker v-model="date" type="daterange" range-separator="~" start-placeholder="开始日期"
                        end-placeholder="结束日期" @change="init"></el-date-picker>
                </el-form-item>
                <el-form-item label="国家" style="margin-bottom: 0;">
                    <CountrySelector v-model="country" @change="init"></CountrySelector>
                </el-form-item>
            </el-form>
        </el-card>
        <el-row :gutter="20">
            <el-col :span="8">
                <el-card>
                    <div>总用户数</div>
                    <div class="number">{{ statData.totalUsers }}</div>
                    <div class="growth">较上月增长{{ statData.totalUsersGrowth }}</div>
                </el-card>
            </el-col>
            <el-col :span="8">
                <el-card>
                    <div>日新增用户数</div>
                    <div class="number">{{ statData.dailyNewUsers }}</div>
                    <div class="growth">较昨日增长{{ statData.dailyNewUsersGrowth }}</div>
                </el-card>
            </el-col>
            <el-col :span="8">
                <el-card>
                    <div>日活跃用户数</div>
                    <div class="number">{{ statData.dailyActiveUsers }}</div>
                    <div class="growth">较昨日增长{{ statData.dailyActiveUsersGrowth }}</div>
                </el-card>
            </el-col>
        </el-row>
        <el-card class="mt-5">
            <div id="userChart" style="width: 100%; height: 400px;"></div>
        </el-card>
        <el-row :gutter="20" class="mt-5">
            <el-col :span="12">
                <el-card>
                    <div id="countryChart" style="width: 100%; height: 400px;"></div>
                </el-card>
            </el-col>
            <el-col :span="12">
                <el-card>
                    <div id="sexChart" style="width: 100%; height: 400px;"></div>
                </el-card>
            </el-col>
        </el-row>
        <el-card class="mt-5">
            <div class="font-bold" style="font-size: 18px;">详细数据</div>
            <el-table :data="tableData" style="width: 100%;">
                <el-table-column label="日期" prop="registerTime"></el-table-column>
                <el-table-column label="新增用户数量" prop="id"></el-table-column>
                <el-table-column label="活跃用户数量" prop="name"></el-table-column>
            </el-table>
            <el-pagination class="mt-5" v-model="page" :page-size="10" :total="1" style="text-align: right;"
                @current-change="userTrend"></el-pagination>
        </el-card>
    </div>
</template>

<script>
import CountrySelector from '@/components/CountrySelector.vue';
import { userNumStats, userCountryDistribution, userGenderDistribution, userStatList, userTrend } from "@/api/statistics/user";
import * as echarts from 'echarts';
import dayjs from 'dayjs';

const getThisWeek = () => {
    const today = dayjs();
    const dayOfWeek = today.day();
    const monday = today.subtract(dayOfWeek === 0 ? 6 : dayOfWeek - 1, 'day').format('YYYY-MM-DD 00:00:00');
    const sunday = today.add(dayOfWeek === 0 ? 0 : 7 - dayOfWeek, 'day').format('YYYY-MM-DD 23:59:59');
    return [monday, sunday];
};

export default {
    components: { CountrySelector },
    data() {
        return {
            date: getThisWeek(),
            country: '',
            statData: {},
            countryList: [],
            page: 1,
            userChart: null,
            countryChart: null,
            sexChart: null,
            tableData: []
        }
    },
    mounted() {
        this.userNumStats();
        this.userCountryDistribution();
        this.userGenderDistribution();
        this.init();
    },
    methods: {
        init() {
            this.userStatList();
            this.userTrend();
        },
        userTrend() {
            userTrend({
                country: this.country,
                startTime: this.date && this.date[0] ? dayjs(this.date[0]).format('YYYY-MM-DD 00:00:00') : null,
                endTime: this.date && this.date[1] ? dayjs(this.date[1]).format('YYYY-MM-DD 23:59:59') : null,
                pageNo: this.page,
                pageSize: 10
            }).then(({ code, result, message }) => {
                if (code === 200) {
                    this.tableData = result.records;
                } else {
                    this.$message.error(message);
                }
            })
        },
        userStatList() {
            userStatList({
                country: this.country,
                startTime: this.date && this.date[0] ? dayjs(this.date[0]).format('YYYY-MM-DD 00:00:00') : null,
                endTime: this.date && this.date[1] ? dayjs(this.date[1]).format('YYYY-MM-DD 23:59:59') : null
            }).then(({ code, result, message }) => {
                if (code === 200) {
                    this.initUserChart(result.records);
                } else {
                    this.$message.error(message);
                }
            })
        },
        userGenderDistribution() {
            userGenderDistribution().then(({ code, result, message }) => {
                if (code === 200) {
                    this.initSexChart(result);
                } else {
                    this.$message.error(message);
                }
            })
        },
        userCountryDistribution() {
            userCountryDistribution().then(({ code, result, message }) => {
                if (code === 200) {
                    this.initCountryChart(result);
                } else {
                    this.$message.error(message);
                }
            })
        },
        userNumStats() {
            userNumStats().then(({ code, result, message }) => {
                if (code === 200) {
                    this.statData = result;
                } else {
                    this.$message.error(message);
                }
            })
        },
        initUserChart(_data) {
            const xData = _data.map(x => x.day);
            const y1Data = _data.map(x => x.newUsers);
            const y2Data = _data.map(x => x.activeUsers);
            this.userChart = echarts.init(document.getElementById('userChart'));
            this.userChart.setOption({
                title: { text: '用户趋势' },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['新增用户', '活跃用户'],
                    right: 0
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: xData
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        name: '新增用户',
                        type: 'line',
                        stack: 'Total',
                        data: y1Data
                    },
                    {
                        name: '活跃用户',
                        type: 'line',
                        stack: 'Total',
                        data: y2Data
                    },
                ]
            });
        },
        initCountryChart(_data) {
            const data = _data.map(x => ({ name: x.name, value: x.count }));
            this.countryChart = echarts.init(document.getElementById('countryChart'));
            this.countryChart.setOption({
                title: { text: '用户国家分布' },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    top: 'center',
                    left: 'right',
                    orient: 'vertical'
                },
                series: [
                    {
                        name: '用户国家分布',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        itemStyle: {
                            borderRadius: 10,
                            borderColor: '#fff',
                            borderWidth: 2
                        },
                        label: {
                            show: false,
                            position: 'center'
                        },
                        labelLine: {
                            show: false
                        },
                        data: data
                    }
                ]
            });
        },
        initSexChart(_data) {
            const data = _data.map(x => ({ name: x.name, value: x.count }));
            this.sexChart = echarts.init(document.getElementById('sexChart'));
            this.sexChart.setOption({
                title: { text: '用户性别比例' },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    top: 'center',
                    left: 'right',
                    orient: 'vertical'
                },
                series: [
                    {
                        name: '用户性别比例',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        itemStyle: {
                            borderRadius: 10,
                            borderColor: '#fff',
                            borderWidth: 2
                        },
                        label: {
                            show: false,
                            position: 'center'
                        },
                        labelLine: {
                            show: false
                        },
                        data: data
                    }
                ]
            });
        }
    }
}
</script>

<style lang="less" scoped>
.number {
    font-size: 24px;
    font-weight: bold;
}

.growth {
    color: #409EFF;
}
</style>